import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';
import { z } from 'zod';

import { Station } from '@/components/management/Station';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';

const zValidateSearch = z.object({
  search: z.string().optional(),
  organizationId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/management/stations/')({
  validateSearch: zValidateSearch,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: StationsRoute,
  beforeLoad: () => ({ breadcrumb: null }),
});
function StationsRoute() {
  const { search, organizationId } = Route.useSearch();

  return (
    <Fragment>
      <AdministrationHeader
        canExport
        label="Stationen und P+R Anlagen"
        organizationId={organizationId}
        search={search}
      />
      <AdministrationBody>
        <Station />
      </AdministrationBody>
    </Fragment>
  );
}
